<template>
  <ModalPage  :goBackTo="{name: 'student'}" :canGoBack="canGoBack">
    <div class="flex-shrink bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
      <div class="mb-3 text-center">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Updating <StudentName :student="student" v-slot="{display}">{{display}}</StudentName>
        </h3>
      </div>
      <StudentInfoForm :student="student" :gradeLevels="gradeLevels" />
    </div>

    <div class="flex border-t my-8 pt-5 border-cool-gray-200 px-4">
      <div class="flex-grow">
        <div v-for="homeNumber in student.homeNumbers" class="flex justify-between items-center mb-4" :key="homeNumber.id">
          <div>
            <div>
              {{homeNumber.label}}
            </div>
            <div>
              {{homeNumber.formattedNumber}}
            </div>
          </div>
          <div>
            <StudentHomeNumberDeleteForm
              :student="student"
              :homeNumber="homeNumber"
            />
          </div>
        </div>
        <StudentHomeNumberCreateForm :student="student"/>
      </div>
    </div>
  </ModalPage>
</template>

<script>
import ModalPage            from '@/components/ModalPage.vue'
import StudentName            from '@/components/StudentName.vue'
import StudentInfoForm  from '@/components/StudentInfoForm.vue'
import StudentHomeNumberCreateForm  from '@/components/StudentHomeNumberCreateForm.vue'
import StudentHomeNumberDeleteForm  from '@/components/StudentHomeNumberDeleteForm.vue'

import StudentQuery     from '@/queries/Student.gql'
import GradeLevelsQuery from '@/queries/GradeLevels.gql'

import { preloadMany }  from '@/preloader'
import { tz }           from '@/tz'


const preloadQueries = (to) => {
  return [
    {
      query: StudentQuery,
      queryName: 'student',
      variables: {
        id: to.params.studentId,
        tz: tz()
      }
    },

    {
      query: GradeLevelsQuery,
      queryName: 'gradeLevels',
      variables: {
        teamId: to.params.teamId
      }
    }
  ]
}

export default {
  components: {
    ModalPage,
    StudentInfoForm,
    StudentHomeNumberCreateForm,
    StudentHomeNumberDeleteForm,
    StudentName,
  },

  props: {
    currentUser: {
      type: Object,
      required: true
    },
    teamId: {
      type: String,
      required: true
    },
    studentId: {
      type: String,
      required: true,
    },
    canGoBack: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      student: {}
    }
  },

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next,
      mountedVm: this
    })
  },

  apollo: {
    student: {
      query: StudentQuery,
      variables() {
        return {
          id: this.studentId,
          tz: tz()
        }
      },
      fetchPolicy: 'cache-first'
    },

    gradeLevels: {
      query: GradeLevelsQuery,
      queryName: 'gradeLevels',
      variables() {
        return { teamId: this.teamId }
      },
      fetchPolicy: 'cache-first'
    }
  },
}
</script>
